import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { TimesheetsListResponse } from "@/actions/ssr/attendance/getTimesheetsSSR";

interface TimesheetsState {
  timesheets: TimesheetsListResponse;
  clientFetched: boolean;
}

const EMPTY_COUNTS = {
  all: 0,
  clocked_in: 0,
  break: 0,
  clocked_out: 0,
  not_started: 0,
  absent: 0,
};

const initialState: TimesheetsState = {
  timesheets: {
    count: 0,
    total_pages: 0,
    current_page: 1,
    results: [],
    counts: { ...EMPTY_COUNTS },
    global_counts: { ...EMPTY_COUNTS },
  },
  clientFetched: false,
};

const timesheetsSlice = createSlice({
  name: "timesheets",
  initialState,
  reducers: {
    setTimesheets(state, action: PayloadAction<TimesheetsListResponse>) {
      state.clientFetched = true;
      state.timesheets = action.payload;
    },
    setTimesheetsFromSSR(state, action: PayloadAction<TimesheetsListResponse>) {
      if (state.clientFetched) return;
      state.timesheets = action.payload;
    },
  },
});

export const { setTimesheets, setTimesheetsFromSSR } = timesheetsSlice.actions;
export default timesheetsSlice.reducer;
